import { UserStats } from '@/model/data-object/UserStats'
import { UserActivity } from '@/model/data-object/UserActivity'
import { AbstractUser } from '@/model/data-object/AbstractUser'

export class User extends AbstractUser {
  email = ''
  isHideSubscribedUsers = true
  isBanned = false
  isHideFollowers = true
  isPayingCustomer = true
  activity: UserActivity = new UserActivity()
  stats: UserStats = new UserStats()
}
